var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"move mv1 is-fullwidth"},[_c('h2',[_vm._v("Change \""+_vm._s(_vm.question.title)+"\" to a:")]),_c('div',{staticClass:"columns mt1"},[_c('div',{staticClass:"column"},[_c('ul',[_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('singletext', 0) }
            ],on:{"click":function($event){return _vm.changeType('singletext', 0)}}},[_vm._v("\n            Single Text\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('multitext', 0) }
            ],on:{"click":function($event){return _vm.changeType('multitext', 0)}}},[_vm._v("\n            Multi Text\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('date', 0) }
            ],on:{"click":function($event){return _vm.changeType('date', 0)}}},[_vm._v("\n            Date\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('multichoice', 0) }
            ],on:{"click":function($event){return _vm.changeType('multichoice', 0)}}},[_vm._v("\n            Multi Choice\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('checkbox', 0) }
            ],on:{"click":function($event){return _vm.changeType('checkbox', 0)}}},[_vm._v("\n            Checkboxes\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('file', 10) }
            ],on:{"click":function($event){return _vm.changeType('file', 10)}}},[_vm._v("\n            File\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('stripe', 11) }
            ],on:{"click":function($event){return _vm.changeType('stripe', 11)}}},[_vm._v("\n            Stripe\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('instruction', 13) }
            ],on:{"click":function($event){return _vm.changeType('instruction', 13)}}},[_vm._v("\n            Instruction\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('video', 14) }
            ],on:{"click":function($event){return _vm.changeType('video', 14)}}},[_vm._v("\n            Video\n          ")])])])]),_c('div',{staticClass:"column"},[_c('ul',[_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('multitext', 1) }
            ],on:{"click":function($event){return _vm.changeType('multitext', 1)}}},[_vm._v("\n            Name\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('email', 2) }
            ],on:{"click":function($event){return _vm.changeType('email', 2)}}},[_vm._v("\n            Email\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('zip', 5) }
            ],on:{"click":function($event){return _vm.changeType('zip', 5)}}},[_vm._v("\n            Zip Code\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('phone', 4) }
            ],on:{"click":function($event){return _vm.changeType('phone', 4)}}},[_vm._v("\n            Phone\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('multichoice', 12) }
            ],on:{"click":function($event){return _vm.changeType('multichoice', 12)}}},[_vm._v("\n            Referral Reason\n          ")])]),_c('li',[_c('button',{class:[
              'button',
              'is-link',
              { 'is-primary is-outlined': _vm.current('casegrid', 0) }
            ],on:{"click":function($event){return _vm.changeType('casegrid', 0)}}},[_vm._v("\n            Case Grid\n          ")])])])])]),_c('div',{staticClass:"field is-grouped mt2 has-text-right"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-link",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('hide')}}},[_vm._v("\n        Cancel\n      ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }